module.exports = __webpack_public_path__ + "media/video1.3afd439e.mp4";